import React, { useMemo } from 'react'
import { useApp } from '../../../context/AppProvider'
import { isEmpty } from '../../../services/common'
import { Parser } from '../../common'
import ListOfSituations from '../list-of-situations/ListOfSituations'

const BlockCase = ({ block = {} }) => {
    const { childrens, attributes } = block
    const { selectedCase } = useApp()

    const blocksToParse = useMemo(() => {
        const hasId = childrens?.some((child) => selectedCase?.includes(child?.attributes?.id))
        if (isEmpty(selectedCase) || !hasId) return childrens

        return childrens?.filter((child) => selectedCase?.includes(child?.attributes?.id))
    }, [childrens, selectedCase])

    return (
        <div className="baseocom-block-case">
            {childrens ? (
                attributes?.affichage === 'onglet' ? (
                    <ListOfSituations block={block} />
                ) : (
                    <Parser content_block={blocksToParse} />
                )
            ) : null}
        </div>
    )
}

export default BlockCase
